import React, { useContext, useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Table,
  Typography,
  Row,
  Col,
  Divider,
  Card,
  Descriptions,
  DescriptionsProps,
  Spin,
  Breadcrumb,
  Timeline,
  Result,
  Splitter,
  Alert,
  Select,
  message,
} from "antd";
import {
  fetchAccReqDetails,
  fetchAccReqObjectDetails,
  fetchAccRequestDetails,
  fetchCcReqDetails,
  fetchCcReqObjectDetails,
  updateAccApprovalRequest,
  updateccApprovalRequest,
} from "../../core/services/account-request.service";
import { CheckCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { format, set } from "date-fns";
import "./accRequestDetail.css";
import {
  AccApproval,
  accRequestDetail,
  AccRequestObject,
} from "../../core/interfaces/AccRequestData";
import { appInsights } from "../../core/services/insight.service";
import { UserContext } from "../../context/user-context";
import axios from "axios";
import { ResultProps } from "antd/lib";

const { TextArea } = Input;
const { Title } = Typography;

const AccRequestDetail: React.FC = () => {
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [requestData, setRequestData] = useState<accRequestDetail>();
  const user = useContext(UserContext);
  const [attachments, setAttachments] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [spinning, setSpinning] = React.useState(false);
  const [requestObjectData, setRequestObjectData] = useState<
    AccRequestObject[]
  >([]);
  const [err, seterr] = useState<boolean>(false);
  const [approvalData, setApprovalData] = useState<AccApproval | null>(null); // State to hold approval data
  const [visible, setVisible] = useState<boolean>(false);
  const [approvalReports, setApprovalReports] = useState<
    { approver: string; report: string }[]
  >([]);
  const navigate = useNavigate();
  const [selectedReport, setSelectedReport] = useState<string>(""); // For the currently selected report
  const [showFullHistory, setShowFullHistory] = useState<boolean>(false);
  const [pendingOn, setPendingOn] = useState<string>(user.email ?? ""); // Simulated pending approver
  const [pending, setPending] = useState<boolean>(false); // Simulated pending state
  const [userInBpc, setUserBpc] = useState<boolean>(false);
  const [pendingJde, setPendingJde] = useState<boolean>(false);
  const location = useLocation();
 // const { requestNumber,reqType,frompending,userEmail } = useParams();

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const query = useQuery();
const requestNumber = query.get("requestNumber");
const reqType = query.get("reqType");
const frompending:boolean = Boolean(query.get("frompending")!="false");
const userEmail = query.get('userEmail')

  useEffect(() => {
    setSpinning(true);
    const fetchDataAsync = async () => {
      try {
        appInsights.trackEvent({
          name: "Fetching Account Request Data",
          properties: {
            requestNumber: requestNumber,
            reqType: reqType,
          },
        });
        await fetchdata();
        appInsights.trackEvent({
          name: "Account Request Data Fetched Successfully",
          properties: {
            requestNumber: requestNumber,
            reqType: reqType,
          },
        });
      } catch (error) {
        setError(error);
        appInsights.trackException({
          error: error as Error,
          properties: {
            requestNumber: requestNumber,
            reqType: reqType,
          },
        });
        setError((error as any).message);
      } finally {
        setSpinning(false);
      }
    };
    fetchDataAsync();
  }, []);

  const columns =
    reqType == "1"
      ? [
          { title: "S/N", dataIndex: "Requestid", key: "sn" },
          { title: "Account Name", dataIndex: "Acctname", key: "accountName" },
          { title: "Cost Center", dataIndex: "Ccenter", key: "costCenter" },
          { title: "Object", dataIndex: "Acctobj", key: "object" },
          { title: "Subsidiary", dataIndex: "Subsidiary", key: "subsidiary" },
        ]
      : [
          { title: "S/N", dataIndex: "requestID", key: "requestID" },
          { title: "Business Unit", dataIndex: "ccenter", key: "ccenter" },
          {
            title: "Business Unit Description",
            dataIndex: "ccdesc",
            key: "ccenter",
          },
        ];
  const category1: DescriptionsProps["items"] =
    reqType == "1"
      ? [
          {
            key: "RC1",
            label: "JC Processes",
            children: requestData?.request[0].rC1 ?? "-",
          },
          {
            key: "RC2",
            label: "JC Components/Deliv",
            span: "filled",
            children: requestData?.request[0].rC2 ?? "",
          },
          {
            key: "RC3",
            label: "JC DISWin",
            span: "filled",
            children: requestData?.request[0].rC3 ?? "",
          },
          {
            key: "RC4",
            label: "JC Intangible/Tangible",
            span: "filled",
            children: requestData?.request[0].rC4 ?? "",
          },
          {
            key: "RC5",
            label: "Interface Control 1",
            span: "filled",
            children: requestData?.request[0].rC5 ?? "",
          },
          {
            key: "RC6",
            label: "Interface Control 2",
            span: "filled",
            children: requestData?.request[0].rC6 ?? "",
          },
          {
            key: "RC7",
            label: "Management Report 2",
            span: "filled",
            children: requestData?.request[0].rC7 ?? "",
          },
          {
            key: "RC8",
            label: "Management Report 3",
            span: "filled",
            children: requestData?.request[0].rC8 ?? "",
          },
          {
            key: "RC9",
            label: "GA Reporting 1",
            span: "filled",
            children: requestData?.request[0].rC9 ?? "",
          },
          {
            key: "RC10",
            label: "JV Posting Edit Contr",
            span: "filled",
            children: requestData?.request[0].rC10 ?? "",
          },
        ]
      : [
          {
            key: "RC1",
            label: "Management",
            children: requestData?.request[0].rC1 ?? "-",
          },
          {
            key: "RC2",
            label: "Division",
            span: "filled",
            children: requestData?.request[0].rC2 ?? "",
          },
          {
            key: "RC3",
            label: "Sub-Division",
            span: "filled",
            children: requestData?.request[0].rC3 ?? "",
          },
          {
            key: "RC4",
            label: "Department",
            span: "filled",
            children: requestData?.request[0].rC4 ?? "",
          },
          {
            key: "RC5",
            label: "Sub-Department",
            span: "filled",
            children: requestData?.request[0].rC5 ?? "",
          },
          {
            key: "RC6",
            label: "Function",
            span: "filled",
            children: requestData?.request[0].rC6 ?? "",
          },
          {
            key: "RC7",
            label: "Allocations - Materials",
            span: "filled",
            children: requestData?.request[0].rC7 ?? "",
          },
          {
            key: "RC8",
            label: "Allocations - GA",
            span: "filled",
            children: requestData?.request[0].rC8 ?? "",
          },
          {
            key: "RC9",
            label: "Allocations - OpRes",
            span: "filled",
            children: requestData?.request[0].rC9 ?? "",
          },
          {
            key: "RC10",
            label: "Allocation - Tiers",
            span: "filled",
            children: requestData?.request[0].rC10 ?? "",
          },
        ];

  const category2: DescriptionsProps["items"] =
    reqType == "1"
      ? [
          {
            key: "RC11",
            label: "JV Chargeability",
            children: requestData?.request[0].rC11 ?? "",
          },
          {
            key: "RC12",
            label: "JV Division of Interest",
            children: requestData?.request[0].rC12 ?? "",
          },
          {
            key: "RC13",
            label: "Partner Requirement 4",
            children: requestData?.request[0].rC13 ?? "",
          },
          {
            key: "RC14",
            label: "Management Report 1",
            children: requestData?.request[0].rC14 ?? "",
          },
          {
            key: "RC15",
            label: "JDE Localization",
            children: requestData?.request[0].rC15 ?? "",
          },
          {
            key: "RC16",
            label: "Currency Restate 1",
            children: requestData?.request[0].rC16 ?? "",
          },
          {
            key: "RC17",
            label: "Currency Restate 2",
            children: requestData?.request[0].rC17 ?? "",
          },
          {
            key: "RC18",
            label: "Currency Restate 3",
            children: requestData?.request[0].rC18 ?? "",
          },
          {
            key: "RC19",
            label: "JDE Localization 2",
            children: requestData?.request[0].rC19 ?? "",
          },
          {
            key: "RC20",
            label: "JDE Localization 3",
            children: requestData?.request[0].rC20 ?? "",
          },
        ]
      : [
          {
            key: "11",
            label: "JV Chargeability",
            children: requestData?.request[0].rC11 ?? "",
          },
          {
            key: "12",
            label: "JV Code",
            children: requestData?.request[0].rC12 ?? "",
          },
          {
            key: "13",
            label: "Business Activity",
            children: requestData?.request[0].rC13 ?? "",
          },
          {
            key: "14",
            label: "Primary Discipline",
            children: requestData?.request[0].rC14 ?? "",
          },
          {
            key: "15",
            label: "TBD - 15",
            children: requestData?.request[0].rC15 ?? "",
          },
          {
            key: "16",
            label: "SO Approval Route",
            children: requestData?.request[0].rC16 ?? "",
          },
          {
            key: "17",
            label: "Interface - Control 1",
            children: requestData?.request[0].rC17 ?? "",
          },
          {
            key: "18",
            label: "Interface - Control 2",
            children: requestData?.request[0].rC18 ?? "",
          },
          {
            key: "19",
            label: "Localization 1",
            children: requestData?.request[0].rC19 ?? "",
          },
          {
            key: "20",
            label: "Localization 2",
            children: requestData?.request[0].rC20 ?? "",
          },
        ];

  const category3: DescriptionsProps["items"] =
    reqType == "1"
      ? [
          {
            key: "RC21",
            label: "Alternate Account",
            children: requestData?.request[0].rC21 ?? "",
          },
          {
            key: "RC22",
            label: "Ariba Interface Flag",
            children: requestData?.request[0].rC22 ?? "",
          },
          {
            key: "RC23",
            label: "SAP Asset Class",
            children: requestData?.request[0].rC23 ?? "",
          },
          {
            key: "RC24",
            label: "Tax 1",
            children: requestData?.request[0].rC24 ?? "",
          },
          {
            key: "RC25",
            label: "Tax 2",
            children: requestData?.request[0].rC25 ?? "",
          },
          {
            key: "RC26",
            label: "Tax 3",
            children: requestData?.request[0].rC26 ?? "",
          },
          {
            key: "RC27",
            label: "PSC Code",
            children: requestData?.request[0].rC27 ?? "",
          },
          {
            key: "RC28",
            label: "Recon Frequency",
            children: requestData?.request[0].rC28 ?? "",
          },
          {
            key: "RC29",
            label: "Recon Responsible",
            children: requestData?.request[0].rC29 ?? "",
          },
          {
            key: "RC30",
            label: "Partner Requirement 1",
            children: requestData?.request[0].rC30 ?? "",
          },
        ]
      : [
          {
            key: "1",
            label: "Approver",
            children: requestData?.request[0].rC21 ?? "",
          },
          {
            key: "2",
            label: "Financial Accounting",
            children: requestData?.request[0].rC22 ?? "",
          },
          {
            key: "3",
            label: "Joint Venture",
            children: requestData?.request[0].rC23 ?? "",
          },
          {
            key: "4",
            label: "PSC",
            children: requestData?.request[0].rC24 ?? "",
          },
          {
            key: "5",
            label: "Gas",
            children: requestData?.request[0].rC25 ?? "",
          },
          {
            key: "6",
            label: "InterCo",
            children: requestData?.request[0].rC26 ?? "",
          },
          {
            key: "7",
            label: "Allocation",
            children: requestData?.request[0].rC27 ?? "",
          },
          {
            key: "8",
            label: "Fixed Asset",
            children: requestData?.request[0].rC28 ?? "",
          },
          {
            key: "9",
            label: "Production Accounting",
            children: requestData?.request[0].rC29 ?? "",
          },
          {
            key: "10",
            label: "JDE Implementation",
            children: requestData?.request[0].rC30 ?? "",
          },
        ];

  const Requestapproval = !frompending
    ? [
        {
          dot:
            requestData?.requestApprovals?.[0]?.lineAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "Approver",
          children:
            requestData?.requestApprovals?.[0]?.line == ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.line,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.faAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "Financial Accounting",
          children:
            requestData?.requestApprovals?.[0]?.fa == ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.fa,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.jvAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "Joint Venture",
          children:
            requestData?.requestApprovals?.[0]?.jv == ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.jv,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.pscAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "PSC",
          children:
            requestData?.requestApprovals?.[0]?.psc == ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.psc,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.gasAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "Gas",
          children:
            requestData?.requestApprovals?.[0]?.gas == ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.gas,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.interAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "InterCo",
          children:
            requestData?.requestApprovals?.[0]?.inter == ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.inter,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.alloAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "Allocation",
          children:
            requestData?.requestApprovals?.[0]?.allo == ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.allo,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.fixAssAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "Fixed Asset",
          children:
            requestData?.requestApprovals?.[0]?.fixAss == ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.fixAss,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.prodAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "Production Accounting",
          children:
            requestData?.requestApprovals?.[0]?.prod == ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.prod,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.compAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "JDE Implementation",
          children:  " - "
          
        },
      ]
    : [
        {
          dot:
            requestData?.requestApprovals?.[0]?.lineAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : requestData?.requestApprovals?.[0]?.line ==
                requestData?.requestApprovals?.[0]?.pendingOn &&
              requestData?.requestApprovals?.[0]?.pendingOn == pendingOn ? (
              <LoadingOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          className:
            requestData?.requestApprovals?.[0]?.lineAppr === "Y"
              ? "blue-tail"
              : "grey-tail",
          label: "Approver",
          children:
            requestData?.requestApprovals?.[0]?.line == ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.line,
        },

        {
          dot:
            requestData?.requestApprovals?.[0]?.faAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : requestData?.requestApprovals?.[0]?.fa ==
                requestData?.requestApprovals?.[0]?.pendingOn &&
              requestData?.requestApprovals?.[0]?.pendingOn === pendingOn ? (
              <LoadingOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          className:
            requestData?.requestApprovals?.[0]?.faAppr === "Y"
              ? "blue-tail"
              : "grey-tail",

          label: "Financial Accounting",
          children:
            requestData?.requestApprovals?.[0]?.fa === ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.fa,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.jvAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : requestData?.requestApprovals?.[0]?.jv ==
                requestData?.requestApprovals?.[0]?.pendingOn &&
              requestData?.requestApprovals?.[0]?.pendingOn === pendingOn ? (
              <LoadingOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "Joint Venture",
          className:
            requestData?.requestApprovals?.[0]?.jvAppr === "Y"
              ? "blue-tail"
              : "grey-tail",
          children:
            requestData?.requestApprovals?.[0]?.jv === ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.jv,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.pscAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : requestData?.requestApprovals?.[0]?.psc?.toLowerCase() ==
                requestData?.requestApprovals?.[0]?.pendingOn?.toLowerCase() &&
              requestData?.requestApprovals?.[0]?.pendingOn?.toLowerCase() ===
                pendingOn.toLowerCase() ? (
              <LoadingOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "PSC",
          className:
            requestData?.requestApprovals?.[0]?.pscAppr === "Y"
              ? "blue-tail"
              : "grey-tail",
          children:
            requestData?.requestApprovals?.[0]?.psc === ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.psc,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.gasAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : requestData?.requestApprovals?.[0]?.gas ==
                requestData?.requestApprovals?.[0]?.pendingOn &&
              requestData?.requestApprovals?.[0]?.pendingOn === pendingOn ? (
              <LoadingOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "Gas",
          className:
            requestData?.requestApprovals?.[0]?.gasAppr === "Y"
              ? "blue-tail"
              : "grey-tail",

          children:
            requestData?.requestApprovals?.[0]?.gas === ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.gas,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.interAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : requestData?.requestApprovals?.[0]?.inter ==
                requestData?.requestApprovals?.[0]?.pendingOn &&
              requestData?.requestApprovals?.[0]?.pendingOn === pendingOn ? (
              <LoadingOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "InterCo",
          className:
            requestData?.requestApprovals?.[0]?.interAppr === "Y"
              ? "blue-tail"
              : "grey-tail",

          children:
            requestData?.requestApprovals?.[0]?.inter === ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.inter,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.alloAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : requestData?.requestApprovals?.[0]?.allo ==
                requestData?.requestApprovals?.[0]?.pendingOn &&
              requestData?.requestApprovals?.[0]?.pendingOn === pendingOn ? (
              <LoadingOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "Allocation",
          className:
            requestData?.requestApprovals?.[0]?.alloAppr === "Y"
              ? "blue-tail"
              : "grey-tail",

          children:
            requestData?.requestApprovals?.[0]?.allo === ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.allo,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.fixAssAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : requestData?.requestApprovals?.[0]?.fixAss ==
                requestData?.requestApprovals?.[0]?.pendingOn &&
              requestData?.requestApprovals?.[0]?.pendingOn === pendingOn ? (
              <LoadingOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "Fixed Asset",
          className:
            requestData?.requestApprovals?.[0]?.fixAssAppr === "Y"
              ? "blue-tail"
              : "grey-tail",

          children:
            requestData?.requestApprovals?.[0]?.fixAss === ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.fixAss,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.prodAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : requestData?.requestApprovals?.[0]?.prod ==
                requestData?.requestApprovals?.[0]?.pendingOn &&
              requestData?.requestApprovals?.[0]?.pendingOn === pendingOn ? (
              <LoadingOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "Production Accounting",
          className:
            requestData?.requestApprovals?.[0]?.prodAppr === "Y"
              ? "blue-tail"
              : "grey-tail",

          children:
            requestData?.requestApprovals?.[0]?.prod === ""
              ? " - "
              : requestData?.requestApprovals?.[0]?.prod,
        },
        {
          dot:
            requestData?.requestApprovals?.[0]?.compAppr === "Y" ? (
              <CheckCircleOutlined />
            ) : (requestData?.requestApprovals?.[0]?.comp ==
                requestData?.requestApprovals?.[0]?.pendingOn &&
                requestData?.requestApprovals?.[0]?.pendingOn === pendingOn) ||
              userInBpc ? (
              <LoadingOutlined />
            ) : (
              <CheckCircleOutlined style={{ color: "grey" }} />
            ),
          label: "JDE Implementation",
          className:
            requestData?.requestApprovals?.[0]?.compAppr === "Y"
              ? "blue-tail"
              : "grey-tail",

          children:  " - "
          
        },
      ];

  const fetchdata = async () => {
    try {
      if (
        userEmail !== undefined &&
        userEmail !== null
      ) {
        setPending(true);

        await featchAccReqDetailsData(
          requestNumber??"",
          reqType??"",
          userEmail??""
        );
      } else {
        setPending(false);
        await featchAccReqDetailsData(
          requestNumber??"",
          reqType??""
        );
      }
    } catch (error) {
      setError((error as any).message);
      appInsights.trackException({
        error: error as Error,
        severityLevel: 3,
        properties: {
          requestNumber: requestNumber,
          reqType: reqType,
        },
      });
    }
  };

  const featchAccReqDetailsData = async (
    requestNumber: string,
    reqType: string,
    email?: string
  ) => {
    try {
      if (reqType === "2") {
        const response = await fetchCcReqDetails(
          requestNumber,
          email ?? "null"
        );
        if (response[0].requestApprovals && response[0].requestApprovals[0]) {
          response[0].requestApprovals[0].pendingOn =
            response[0].requestApprovals[0].pendingon ?? "";
        }
        setRequestData(response[0]);

        setApprovalData(response[0]?.requestApprovals?.[0] ?? null);
        setPendingOn(
          response[0].requestApprovals?.[0].pendingOn ??
            response[0].requestApprovals?.[0].pendingon ??
            ""
        );
        setPendingJde(
          response[0].requestApprovals?.[0]?.status == 27 ? true : false
        );
        setUserBpc(response[0].userInBpc ?? false);
        if (response[0]?.requestApprovals?.length) {
          response[0].requestApprovals.forEach((approvalsLog) => {
            generateReports(approvalsLog); // Generate reports for all approvers
          });
        }
        appInsights.trackEvent({
          name: "CC Request Details Fetched",
          properties: { requestNumber: requestNumber },
        });

        form.setFieldsValue({
          requester: response[0].request[0].requesterName,
          requestDate: response[0].request[0].requestDate
            ? format(new Date(response[0].request[0].requestDate), "M/d/yyyy")
            : "",
          actionCode: response[0].request[0].actioncCode,
          company: response[0].request[0].company,
          reason: response[0].request[0].reason,
          postingEdit: response[0].request[0].postEdit,
          uom: response[0].request[0].uom,
          // Add other fields as necessary
        });
        const mappedData = response[0].requestObjects?.map(
          (item: any, index: number) => ({
            key: index + 1, // Add a unique key for each row
            Requestid: item.requestID,
            ccenter: item.ccenter,
            ccdesc: item.ccdesc,
          })
        );
        setRequestObjectData(mappedData ?? []); // Set the mapped data
      } else {
        const response = await fetchAccRequestDetails(
          requestNumber,
          email ?? "null"
        );
        setRequestData(response[0]);
        setApprovalData(response[0]?.requestApprovals?.[0] ?? null);
        setPendingOn(response[0].requestApprovals?.[0].pendingOn ?? "");
        setPending(
          response[0].requestApprovals?.[0]?.status?.toString()[0] == "-"
            ? false
            : true
        );

        setPendingJde(
          response[0].requestApprovals?.[0]?.status == 27 ? true : false
        );

        setUserBpc(response[0].userInBpc ?? false);
        if (response[0]?.requestApprovals?.length) {
          response[0].requestApprovals.forEach((approvalsLog) => {
            generateReports(approvalsLog); // Generate reports for all approvers
          });
        }
        appInsights.trackEvent({
          name: "Account Request Details Fetched",
          properties: { requestNumber: requestNumber },
        });

        form.setFieldsValue({
          requester: response[0].request[0].requesterName,
          requestDate: response[0].request[0].requestDate
            ? format(new Date(response[0].request[0].requestDate), "M/d/yyyy")
            : "",
          actionCode: response[0].request[0].actioncCode,
          company: response[0].request[0].company,
          reason: response[0].request[0].reason,
          postingEdit: response[0].request[0].postEdit,
          uom: response[0].request[0].uom,
          // Add other fields as necessary
        });
        const mappedData = response[0].requestObjects?.map(
          (item: any, index: number) => ({
            key: index + 1, // Add a unique key for each row
            Requestid: item.requestId,
            Acctname: item.acctName,
            Ccenter: item.ccenter,
            Acctobj: item.acctObj,
            Subsidiary: item.subsidiary,
          })
        );
        setRequestObjectData(mappedData ?? []); // Set the mapped data
      }
    } catch (error) {
      setError((error as any).message);
      appInsights.trackException({
        error: error as Error,
        severityLevel: 3,
        properties: { requestNumber: requestNumber, reqType: reqType },
      });
    }
  };

  const handleSubmit = (values: any) => {
    // Handle form submission
    appInsights.trackEvent({ name: "Form Submitted", properties: values });
  };

  const getStatusDescription = (status: string) => {
    const statusDescriptions: Record<any, string> = {
      "1": "Pending action by Line Approver",
      "10": "Approved by Line Approver",
      "12": "Approved by Finance Analyst",
      "14": "Approved by Joint Venture Analyst",
      "16": "Approved by PSC Analyst",
      "18": "Approved by GAS Analyst",
      "20": "Approved by Interco Analyst",
      "22": "Approved by Allocations Analyst",
      "24": "Approved by Fixed Assets Analyst",
      "26": "Approved by Production Accounting Analyst",
      "28": "Approved by JDE Analyst",
      "11": "Pending Finance Analyst Approval",
      "13": "Pending Joint Venture Analyst Approval",
      "15": "Pending PSC Analyst Approval",
      "17": "Pending GAS Analyst Approval",
      "19": "Pending Interco Analyst Approval",
      "21": "Pending Allocations Analyst Approval",
      "23": "Pending Fixed Assets Analyst Approval",
      "25": "Pending Production Accounting Analyst Approval",
      "27": "Pending action by JDE Analyst",

      "-10": "Disapproved by Line Approver",
      "-12": "Disapproved by Finance Analyst",
      "-14": "Disapproved by Joint Venture Analyst",
      "-16": "Disapproved by PSC Analyst",
      "-18": "Disapproved by GAS Analyst",
      "-20": "Disapproved by Interco Analyst",
      "-22": "Disapproved by Allocations Analyst",
      "-24": "Disapproved by Fixed Assets Analyst",

      "-26": "Disapproved by Production Accounting Analyst",
      "-28": "Disapproved by JDE Analyst",
      "99": "Pending final review",
      "0": "Returned",
      "100": "Completed and closed",
      "-100": "Cancelled",
    };
    return statusDescriptions[status] || "Unknown Status";
  };

  const generateReports = (approvalsLog: AccApproval) => {
    const reports: { approver: string; report: string }[] = [];
    let hasDisapproval = false;

    // Line Approval Report
    let approvalReport = `Request`;
    if (approvalsLog.status == 1) {
      approvalReport += ` is <span class='rpt'>${getStatusDescription(
        "1"
      )}</span>, `;
    } else {
      approvalReport += ` was <span class='rpt'>${getStatusDescription(
        approvalsLog.lineAppr === "Y" ? "10" : "-10"
      )}</span> on ${
        approvalsLog.lineDate ?? "N/A"
      } with the following comments: `;
      approvalReport += `<br/><b>&quot;${
        approvalsLog.lineComments ?? "No comments"
      }&quot;</b> - `;
      hasDisapproval = approvalsLog.lineAppr === "Disapproved";
    }
    approvalReport += approvalsLog.line ?? "N/A";
    reports.push({ approver: "Approver", report: approvalReport });

    // JDE Completion Approval Report
    approvalReport = "Request ";
    switch (Math.abs(Number(approvalsLog.status) || 0)) {
      case 27:
        approvalReport += `is <span class='rpt'>${getStatusDescription(
          approvalsLog.status?.toString() || "Unknown"
        )}</span>, `;
        break;
      case 100:
      case 28:
        approvalReport += `was <span class='rpt'>${getStatusDescription(
          approvalsLog.status?.toString() || "Unknown"
        )}</span> on ${
          approvalsLog.compDate ?? "N/A"
        } with the following comments: `;
        approvalReport += `<br/><b>&quot;${
          approvalsLog.compComments ?? "No comments"
        }&quot;</b> - `;
        break;
      default:
        approvalReport +=
          "JDE Implementation of this request <span class='rpt'>Requires all Selected Approvals</span> for action.";
        break;
    }
    approvalReport += approvalsLog.comp ?? "N/A";
    reports.push({ approver: "JDE Implementation", report: approvalReport });

    // If disapproved, stop further processing
    if (hasDisapproval) {
      setApprovalReports(reports);
      return;
    }

    // Process other approvers
    const approvers = [
      {
        name: "Financial Accounting",
        appr: approvalsLog.faAppr,
        date: approvalsLog.faDate,
        comments: approvalsLog.faComments,
        status: 12,
      },
      {
        name: "Joint Venture",
        appr: approvalsLog.jvAppr,
        date: approvalsLog.jvDate,
        comments: approvalsLog.jvComments,
        status: 14,
      },
      {
        name: "PSC",
        appr: approvalsLog.pscAppr,
        date: approvalsLog.pscDate,
        comments: approvalsLog.pscComments,
        status: 16,
      },
      {
        name: "Gas",
        appr: approvalsLog.gasAppr,
        date: approvalsLog.gasDate,
        comments: approvalsLog.gasComments,
        status: 18,
      },
      {
        name: "Interco",
        appr: approvalsLog.interAppr,
        date: approvalsLog.interDate,
        comments: approvalsLog.interComments,
        status: 20,
      },
      {
        name: "Allocation",
        appr: approvalsLog.alloAppr,
        date: approvalsLog.alloDate,
        comments: approvalsLog.alloComments,
        status: 22,
      },
      {
        name: "Fixed Asset",
        appr: approvalsLog.fixAssAppr,
        date: approvalsLog.fixAssDate,
        comments: approvalsLog.fixAssComments,
        status: 24,
      },
      {
        name: "Production Accounting",
        appr: approvalsLog.prodAppr,
        date: approvalsLog.prodDate,
        comments: approvalsLog.prodComments,
        status: 26,
      },
    ];

    approvers.forEach((approver) => {
      let approverReport = `${approver.name} Approval: `;
      if (approver.appr) {
        approverReport += `was <span class='rpt'>${getStatusDescription(
          approver.appr === "Y"
            ? approver.status.toString()
            : "-" + approver.status.toString()
        )}</span> on ${approver.date ?? "N/A"} with the following comments: `;
        approverReport += `<br/><b>&quot;${
          approver.comments ?? "No comments"
        }&quot;</b> - `;
      } else {
        approverReport += `Not Required`;
      }
      reports.push({ approver: approver.name, report: approverReport });
    });

    setApprovalReports(reports); // Store all reports in state
  };

  const onFinish = async (values) => {
    try {
       setSpinning(true);
      // Prepare the payload with the required fields
      const data = {
        request: Number(requestNumber), // Use 'requestId' instead of 'request'
        requestId: requestNumber?.toString(), // Use 'requestId' instead of 'request'
        Approved: values.approvalAction,
        Comments: values.comments ?? " ",
      };

      if (reqType == "1") {
        // Call the UpdateApproval API
        const response = await updateAccApprovalRequest(data,user.email??"");
        if (response.status === 200) {
          setSpinning(false);
          message.success("Approval updated successfully!");
          form2.resetFields(); // Reset the form after successful submission
          const result: ResultProps = {
            status: "success",
            title: "Approval Updated successfully",
          };
          navigate("/result", {
            state: {
              status: "success",
              title: "Approval Updated successfully",
            },
          });
        } else {
          setSpinning(false);
          message.error("Failed to update approval. Please try again.");
          const result: ResultProps = {
            status: "error",
            title: "Failed to update approval. Please try again.",
          };
          navigate("/result", {
            state: {
              status: "error",
              title: "Failed to update approval. Please try again.",
            },
          });
        }
      } else {
        const response = await updateccApprovalRequest(data,user.email??"");
        if (response.status === 200) {
          setSpinning(false);
          message.success("Approval updated successfully!");
          form2.resetFields(); // Reset the form after successful submission
          const result: ResultProps = {
            status: "success",
            title: "Approval Updated successfully",
          };
          navigate("/result", {
            state: {
              status: "success",
              title: "Approval Updated successfully",
            },
          });
        } else {
          setSpinning(false);
          message.error("Failed to update approval. Please try again.");
          const result: ResultProps = {
            status: "error",
            title: "Failed to update approval. Please try again.",
          };
          navigate("/result", {
            state: {
              status: "error",
              title: "Failed to update approval. Please try again.",
            },
          });
        }
      }
    } catch (error) {
      setSpinning(false);
      console.error("Error updating approval:", error);
      message.error("An error occurred while updating approval.");
      const result: ResultProps = {
        status: "error",
        title: "An error occurred while updating approval",
      };
      navigate("/result", { state: { result } });
      if (error.response) {
        const errorMessage =
          error.response.data ||
          "An error occurred while updating the approval.";
        message.error(errorMessage);
      } else {
        message.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  return err ? (
    <Result
      status="500"
      title="500"
      subTitle="Sorry, something went wrong."
      extra={<Button type="primary">Back Home</Button>}
    />
  ) : (
    <>
      <Spin spinning={spinning} fullscreen />
      <Breadcrumb
        items={[
          {
            title: "/request detail",
          },
        ]}
      />

      <div className="div-container">
        <Title level={3}>
          {reqType == "1"
            ? "Account Request Details"
            : "Business Request Details"}
        </Title>
        <br />
        <Form
          form={form}
          variant="borderless"
          layout="horizontal"
          onFinish={handleSubmit}
        >
          <Row gutter={12}>
            <Col span={12}>
              <Form.Item label="Requester" name="requester">
                <Input readOnly />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Date" name="requestDate">
                <Input readOnly />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Action Code" name="actionCode">
                <Input style={{ background: "#f5f5f5" }} readOnly />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Company" name="company">
                <Input style={{ background: "#f5f5f5" }} readOnly />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item label="Reason for request" name="reason">
            <Card className="reasoncard">
              <TextArea
                readOnly
                style={{
                  backgroundColor: "#f5f5f5",
                  border: "none",
                  resize: "none", // Prevent resizing
                  height: "100px",
                }}
                value={form.getFieldValue("reason")}
              />
            </Card>
          </Form.Item>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Posting Edit" name="postingEdit">
                <Input readOnly />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Unit of Measure" name="uom">
                <Input readOnly />
              </Form.Item>
            </Col>
          </Row>
          <Table<AccRequestObject>
            columns={columns}
            dataSource={requestObjectData}
            size="middle"
          />
          <Divider />
          <Title level={4}>Attachments</Title>
          {attachments.map((attachment, index) => (
            <div key={index}>
              <a
                href={attachment.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {attachment.name}
              </a>
            </div>
          ))}
          <Divider />
          <Title level={4}>Category Codes 1 - 10</Title>
          <Descriptions
            size="small"
            bordered
            column={1} // Set 2 columns
            labelStyle={{ width: "30%" }}
            contentStyle={{ width: "70%" }}
          >
            {category1.map((item) => (
              <Descriptions.Item key={item.key} label={item.label}>
                {item.children}
              </Descriptions.Item>
            ))}
          </Descriptions>
          <Divider />
          <Title level={4}>Category Codes 11 - 20</Title>
          <Descriptions
            size="small"
            bordered
            column={1} // Set 2 columns
            labelStyle={{ width: "30%" }}
            contentStyle={{ width: "70%" }}
          >
            {category2.map((item) => (
              <Descriptions.Item key={item.key} label={item.label}>
                {item.children}
              </Descriptions.Item>
            ))}
          </Descriptions>
          <Divider />
          <Title level={4}>Category Codes 21 - 30</Title>
          <Descriptions
            size="small"
            bordered
            column={1} // Set 2 columns
            labelStyle={{ width: "30%" }}
            contentStyle={{ width: "70%" }}
          >
            {category3.map((item) => (
              <Descriptions.Item key={item.key} label={item.label}>
                {item.children}
              </Descriptions.Item>
            ))}
          </Descriptions>
          <Divider />
          <Title level={4}>Reviewing Route</Title>
          <Splitter
            style={{
              overflow: "hidden",
              paddingTop: 20,
              height: "auto",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Splitter.Panel
              style={{ overflow: "hidden" }}
              resizable={false}
              defaultSize="50%"
              min="20%"
            >
              <br></br>
              <Timeline
                mode="left"
                style={{ paddingTop: 20 }}
                className="timeline-custom"
              >
                {Requestapproval.map((item, index) => (
                  <Timeline.Item
                    key={index}
                    dot={item.dot}
                    label={item.label}
                    className={item.className}
                  >
                    <a
                      onClick={() => {
                        setVisible(true);
                        setShowFullHistory(false);
                        const report = approvalReports.find(
                          (r) =>
                            r.approver.toLowerCase() ===
                            item.label.toLowerCase()
                        )?.report;
                        setSelectedReport(report ?? "No report available");
                      }}
                    >
                      {" "}
                      {item.children}{" "}
                    </a>
                  </Timeline.Item>
                ))}
              </Timeline>
            </Splitter.Panel>
            <Splitter.Panel
              style={{
                overflow: "hidden",
                maxHeight: "500px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {visible && (
                <div style={{ padding: 20, flex: 1, overflowY: "auto" }}>
                  {showFullHistory ? (
                    <div>
                      <span
                        className="tgl-full-report"
                        title="Click to hide this report and view summary reports"
                        style={{
                          cursor: "pointer",
                          color: "#1890ff",
                          display: "block",
                          marginBottom: "10px",
                        }}
                        onClick={() => setShowFullHistory(false)}
                      >
                        Hide History
                      </span>
                      <div>
                        <p>
                          The request with number{" "}
                          <b>{requestNumber}</b> was entered on{" "}
                          <b>{form.getFieldValue("requestDate")}</b> by{" "}
                          <b>{form.getFieldValue("requester")}</b> with the
                          following given reason: <br />
                          <b>"{form.getFieldValue("reason")}"</b>
                        </p>
                        <div>
                          {approvalReports.length > 0 ? (
                            approvalReports.map((report, index) => (
                              <div key={index} style={{ marginBottom: "10px" }}>
                                <b>{report.approver}:</b>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: report.report,
                                  }}
                                />
                              </div>
                            ))
                          ) : (
                            <p>No Reports Generated...</p>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      <Descriptions
                        title={
                          approvalData?.lineAppr === "Y" &&
                          approvalData?.faAppr === "Y" &&
                          approvalData?.gasAppr === "Y" &&
                          approvalData?.jvAppr === "Y" &&
                          approvalData?.pscAppr === "Y" &&
                          approvalData?.interAppr === "Y" &&
                          approvalData?.alloAppr === "Y" &&
                          approvalData?.compAppr === "Y" &&
                          approvalData?.prodAppr === "Y"
                            ? "The request has been approved"
                            : "The request has been disapproved"
                        }
                      >
                        <Descriptions.Item>
                          <div
                            dangerouslySetInnerHTML={{ __html: selectedReport }}
                          />
                        </Descriptions.Item>
                      </Descriptions>
                    </>
                  )}
                </div>
              )}
              <div
                style={{
                  padding: "10px 20px",
                  borderTop: "1px solid #f0f0f0",
                  textAlign: "center",
                }}
              >
                <a
                  style={{ cursor: "pointer", color: "#1890ff" }}
                  onClick={() => {
                    setShowFullHistory(!showFullHistory);
                    setVisible(true);
                  }}
                >
                  {showFullHistory ? " " : "View Request History"}
                </a>
              </div>
            </Splitter.Panel>
          </Splitter>

          <Divider />
          {!frompending ? (
            <Form.Item>
              <Button
                type="default"
                style={{ marginLeft: "10px" }}
                onClick={() => window.history.back()}
              >
                Back
              </Button>
            </Form.Item>
          ) : (
            ""
          )}
        </Form>

        {/* Conditionally render the approval form */}
        {(user.email?.toLowerCase() == pendingOn.toLowerCase() &&
        pending  && 
        frompending) || userInBpc  ? (
          <>
            <Title level={3}>Approval Action</Title>
            <Form form={form2} layout="vertical" onFinish={onFinish}>
              <Alert
                message={`Your Action: ${userInBpc ? user.email : pendingOn}` }
                type="info"
                showIcon
                style={{ marginBottom: "20px" }}
              />

              <Form.Item
                label="Approval Action"
                name="approvalAction"
                rules={[{ message: "Please select an action!" }]}
                style={{ width: "200px" }}
              >
                <Select>
                  <option value="Y">Approve</option>
                  <option value="N">Disapprove</option>
                </Select>
              </Form.Item>

              <Form.Item
                label="Comments"
                name="comments"
                
              >
                <TextArea rows={4} placeholder="Enter your comments here" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
                <Button
                  type="default"
                  style={{ marginLeft: "10px" }}
                  onClick={() => window.history.back()}
                >
                  Back
                </Button>
              </Form.Item>
            </Form>
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default AccRequestDetail;
